import { ConsentItem } from 'types/consent';
import { Locale } from 'types/I18n';
import onboardingPortal1 from 'static/icons/onboarding_portal1.jpg';

export const consentByLocale: {
    [Locale.en]: ConsentItem[];
} = {
    [Locale.en]: [
        {
            title: "Welcome to MyHR - the People Portal!",
            text: `
MyHR is your central hub for accessing HR services, updates, and support. Whether you are looking for guidance, links to the available learning platforms, or quick answers concerning HR related topics, MyHR is designed to make your experience smooth and personalised.
<br/><br/>
<h4>What you'll find in MyHR</h4>
<ul>
<li>WGPT MyHR AI Assistant: Navigate directly to our new AI-powered assistant, designed for HR-related use cases to help you find what you need quickly and efficiently.</li>
<li>Support Request: Submit queries or issues directly to the HR specialists through the support request service.</li>
<li>Timely Events Banners: Stay informed with banners highlighting current and upcoming HR-related events.</li>
<li>My Learning: Explore links to available learning platforms.</li>
<li>My Team (for line managers): Learn more about the recruitment journey.</li>
<li>Knowledge Collection: Access a rich library of HR articles covering topics like HR employee handbooks, benefits, policies, and processes.</li>
<li>Employee Central: Navigate directly to Employee Central for your profile and personal information, and HR-related processes such as performance and rewarding, careers, and continuous feedback.</li>
</ul>
<h4>Your Data and Privacy</h4>
Wärtsilä processes your personal data to manage the employment or working relationship and to provide HR services and support. The personal data available in this portal and in Employee Central is collected from you directly, generated in the course of your employment or engagement with Wärtsilä, or received from third parties where relevant (e.g., benefits providers, tax authorities).

Full information about how your personal data is processed, including purposes, legal bases, recipients, retention, international transfers, and your rights, is set out in the applicable privacy notice:

<a href="https://wartsila-dcac.cloudvault.m-files.com/#/vault/%7B2C278C26-ECD6-43AD-8D51-69151BE0294A%7D/objects/A5E50CAF-F728-4A99-9B7F-E56C5D8E110D/120/F2452D76-A02A-485C-8D46-1990CAD39C05">Wärtsilä Global Privacy Notice for Employees </a>
            `,
            imageUrl: onboardingPortal1,
        },
    ]
};
